import { HomePageInventoryItem } from '@app/data/clients/inventoryHydrationServiceClient/queries/types';
import { ProcessedSearchResult } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import { SimilarDesignItem } from '@app/data/clients/rbServerSideClient/queries/GetSimilarDesigns/types';
import { AnalyticsComponentName } from '@app/pages/i/analytics';
import { IntlShape } from '@redbubble/next/intl';
import { AnalyticsItemListID } from '@redbubble/next-analytics/gtm';
import {
  RSProductClickedLocationKey,
  RSProductClickedPageTypeKey,
} from '@redbubble/next-provider/rudderstack';
import React, { createContext } from 'react';
import {
  DefaultInventoryItem,
  LicensedProduct,
  RecommendedProduct,
} from 'types/shop-bff/types';
import { SearchUUIDStorageKeyId } from 'utils/searchUUIDStorage';
import { PriceProps } from '../Price';
import { CarouselMediaCardProps } from './types';

/**
 * This type needs updating with each introduction of Carousel Section
 * implementation. eg.
 * export type CarouselSectionDataType = ProductStyleData | SimilarDesign
 */
export type CarouselSectionDataType =
  | DefaultInventoryItem
  | SimilarDesignItem
  | LicensedProduct
  | RecommendedProduct
  | ProcessedSearchResult
  | HomePageInventoryItem;

export type CarouselSectionContextValue = {
  mediaCardPropsMapper: (
    input: CarouselSectionDataType,
    intl?: IntlShape,
    index?: number
  ) => CarouselMediaCardProps | null;
  analytics: {
    componentName: AnalyticsComponentName;
    listID: AnalyticsItemListID;
    inViewTracking?: () => void;
    searchUUIDStorageKey?: SearchUUIDStorageKeyId;
  };
  pricePropsMapper?: (input: CarouselSectionDataType) => PriceProps | null;
  rsLocation?: RSProductClickedLocationKey;
  rsPageType?: RSProductClickedPageTypeKey;
};

export const CarouselSectionContext = createContext<
  CarouselSectionContextValue | undefined
>(undefined);

export function useCarouselSectionContext() {
  const context = React.useContext(CarouselSectionContext);

  if (context === undefined) {
    throw new Error(
      `Carousel compound components cannot be rendered outside the CarouselSectionContext`
    );
  }

  return context;
}
